import type { ApiFetchBlogPostPort } from '~/handlers/ports/api-fetch-blog-post.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiFetchBlogPostAdapter implements ApiFetchBlogPostPort {
  async handle(slug: string): Promise<BlogCore.PostDetail | null> {
    if (!slug) return null;

    const url = `${getApostatudoApiUrl()}/blog/posts/${encodeURIComponent(slug)}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      console.warn(
        `[ApiFetchBlogPost] API returned ${response.status}: ${response.statusText}`,
      );

      return null;
    }

    const json = await response.json();
    const data = json?.data ?? json;

    if (!data || typeof data !== 'object') {
      console.warn('[ApiFetchBlogPost] API response is not an object:', json);

      return null;
    }

    return data as BlogCore.PostDetail;
  }
}
